import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import ForeignRefundsViewModel from "viewModels/finance/refundApprovals/transferRefunds/foreignRefunds/foreignRefundsViewModel";
import TransferRefundsView from "../transferRefundsView";

const ForeignRefundsView: ViewComponent<ForeignRefundsViewModel> = observer(({ vm }) => (
  <TransferRefundsView key={vm.name} vm={vm} />
));

registerView(ForeignRefundsView, ForeignRefundsViewModel);
